import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';

import config from '../config/config';
import { AuthContext } from '../contexts/AuthContext';
import { useWebsite } from '../contexts/WebsiteContext';
import { HOME_PATH } from '../config/routes';

import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import NavigationBar from '../components/NavigationBar';
import DisplayMessage from '../components/DisplayMessage';
import MediaList from '../components/MediaList';

const Login = () => {
  const { t } = useTranslation();
  const { setIsLoading } = useWebsite();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [isCaptchaError, setIsCaptchaError] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { handleLogin, handleLogout, lastVisitedPage } = useContext(AuthContext);

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handlePostLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Vérification du captcha avant la soumission
      if (!captchaToken) {
        setIsCaptchaError(true);
        setIsLoading(false);
        return;
      }
      setIsCaptchaError(false);

      const response = await fetch(`${config.apiUrl}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // On transmet l'objet complet retourné par le WS, incluant token, roles et expiredAt.
        handleLogin(data);
        setError('');
        navigate(lastVisitedPage || HOME_PATH);
      } else {
        setError(t('LOGIN_INVALID_CREDENTIALS'));
        handleLogout();
      }
    } catch (error) {
      setError(t('ERROR_MESSAGE'));
    }
    setIsLoading(false);
  };

  return (
      <div>
        <NavigationBar />
        <h1 className="text-center">{t('LOGIN_LOGIN')}</h1>
        <div className="justify-content-center">
          <div className="kubuni-frame" style={{ maxWidth: '600px', margin: '20px auto', marginBottom: '160px', padding: '10px 30px' }}>
            {error && <DisplayMessage messageType="error" message={error} />}
            <Form onSubmit={handlePostLogin}>
              <Form.Group controlId="formBasicUsername">
                <Form.Label>{t('LOGIN_EMAIL')}</Form.Label>
                <Form.Control
                    type="email"
                    placeholder={t('LOGIN_EMAIL_PLACEHOLDER')}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formBasicPassword" style={{ margin: '20px 0 0 0' }}>
                <Form.Label>{t('LOGIN_PASSWORD')}</Form.Label>
                <Form.Control
                    type="password"
                    placeholder={t('LOGIN_PASSWORD_PLACEHOLDER')}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <div className="text-center">
                <div style={{ margin: '20px auto', width: '300px' }}>
                  {isCaptchaError && <DisplayMessage messageType="error" message={t('CAPTCHA_ERROR')} />}
                  <ReCAPTCHA
                      sitekey={config.recaptchaKey}
                      onChange={handleCaptchaChange}
                  />
                </div>
                <Button variant="primary" type="submit" style={{ marginBottom: "20px" }}>
                  {t('LOGIN_LOGIN')}
                </Button>
              </div>
            </Form>
          </div>
        </div>
        <div className="short-line"></div>
        <MediaList mediaKey="LOGIN_BOTTOM" maxItems={1} isShortLine={true} />
        <Menus />
        <Footer />
      </div>
  );
};

export default Login;
